import React , { useState } from "react";
import { Button, TextField, Typography, Grid } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useDispatch, useSelector } from "react-redux";
import { getScenariosForApproval, rejectMultiple, setState, Upload } from "./scenarioApprovalSlice";
import DeleteIcon from '@mui/icons-material/Delete';


const style = {
   position: "absolute",
   top: "50%",
   left: "50%",
   transform: "translate(-50%, -50%)",
   width: 400,
   bgcolor: "background.paper",
   boxShadow: 24,
   p: 2,
   borderRadius: 1,
};

export default function RejectSelectedModal() {
   const dispatch = useDispatch();
   const [uploadedEditFile, setuploadedEditFile] = useState([]);

   const {
      rejectMultiModalOpen,
      rejectSelectedComment,
      selectedRows,
      scenariosForApproval,
      selectedPeriod,
      selectedScenarioStatus,
      selectedCountryID,
      filepath,
      files,
      searchText
   } = useSelector((store) => store.scenarioApproval);

   function handleClose() {
      dispatch(setState("rejectMultiModalOpen", false));
      dispatch(setState("files",[]));
		setuploadedEditFile([]);
      dispatch(setState("filepath",[]));
      dispatch(setState("rejectSelectedComment",''));
   }

   function setComment(event) {
      const comment = event.target.value;
      dispatch(setState("rejectSelectedComment", comment));
   }

   function search() {
      dispatch(setState("scenarioDetails", null));
      dispatch(setState("rejectSelectedComment",''));
      dispatch(setState("selectedRows",[]));
      dispatch(setState("files",[]));
		setuploadedEditFile([]);
      dispatch(setState("filepath",[]));
		const logedUser = JSON.parse(localStorage.getItem("data"));
		const period = selectedPeriod;
		const scenarioStatus = selectedScenarioStatus;
      const countryId = selectedCountryID;
		const obj = {
			logedUser,
			period,
			scenarioStatus,
			searchText,
         countryId
		};
		dispatch(getScenariosForApproval(obj));
	}

   function rejectSelected() {
      dispatch(Upload({method : "POST"})).then(() => {
      const user = JSON.parse(localStorage.getItem("data"));
      let scenarioList = [];
      for (let i = 0; i < selectedRows.length; ++i) {
         const id = selectedRows[i];
         let scenario = scenariosForApproval.find((item) => item.scenarioID === id);
         scenario = {
            ...scenario,
            rejectionComments: rejectSelectedComment,
           // scenarioFiles : filepath
         }
         const obj = {
            ...scenario,
            user,
         };
         scenarioList.push(obj);
      }
      console.log("Approve_Scenario_RejectSelected", scenarioList);
      dispatch(rejectMultiple(scenarioList)).then(() => {
         handleClose();
         search();
      });
   });
   }
   const handleFileUpload = (event) => {
      const fileObj = event.target.files[0];
      let files = [...uploadedEditFile];
      files.push(fileObj);
      setuploadedEditFile(files);
      dispatch(setState("files", files));
    };
  
    const handleDelete = (name) => {
      const files = uploadedEditFile.filter((file) => file.name !== name);
      setuploadedEditFile(files);
      dispatch(setState("files", files));
    };

   return (
      <Box>
         <Modal open={rejectMultiModalOpen} onClose={handleClose}>
            <Box sx={style}>
               <Typography variant="subtitle2">Comments</Typography>
               <TextField
                  className={'fullWidth'}
						size="large"
						multiline
						rows={6}
						style={{overflowY:'auto'}}
                  value={rejectSelectedComment}
                  onChange={setComment}
               />
               <br />
               <Grid item>
            <Box>
              <input
                type="file"
                onChange={handleFileUpload}
                style={{ display: 'none' }}
                id="fileInput"
                onclick="fileInput.value = null"
                value=""
              />
              <label htmlFor="fileInput">
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "skyBlue.main",
                    color: "blue.main",
                    textTransform: "none",
                    mt: 1,
                    "&:hover": {
                      bgcolor: "blue.main",
                      color: "white.main",
                    },
                  }}
                  component="span"
                >
                  Upload File
                </Button>
              </label>
            </Box>
          </Grid>
          <Grid>
         {uploadedEditFile.map((file) => (
        <Box>
            <div className="file-display">
              <span>{file.name}</span>
              <Button variant="outlined" color="secondary" onClick={() => handleDelete(file.name)}>
                <DeleteIcon />
              </Button>
            </div>
        </Box>
      ))}
      </Grid>
          <br />
          <Box
						sx={{
							display: "flex",
							flexDirection: "row",
							justifyContent: "flex-end",
						}}
					>
               <Button
							sx={{
								bgcolor: "blue.main",
								color: "white.main",
								textTransform: "none",
								fontWeight: "bold",
								mt: 1,
								mr: 2,
								"&:hover": {
									bgcolor: "skyBlue.main",
									color: "black.main",
								},
							}}
							onClick={handleClose}
						>
							Close
						</Button>
               <Button
                  sx={{
                     bgcolor: "blue.main",
                     color: "white.main",
                     textTransform: "none",
                     mt: 1,
                     "&:hover": {
                        bgcolor: "skyBlue.main",
                        color: "black.main",
                     },
                  }}
                  onClick={rejectSelected}
               >
                  Reject
               </Button>
               </Box>
            </Box>
         </Modal>
      </Box>
   );
}
